import { render, staticRenderFns } from "./applicant_import_dialog.vue?vue&type=template&id=63fe1f4c"
import script from "./applicant_import_dialog.vue?vue&type=script&lang=ts"
export * from "./applicant_import_dialog.vue?vue&type=script&lang=ts"
import style0 from "./applicant_import_dialog.vue?vue&type=style&index=0&id=63fe1f4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports